import { render } from "./OptionIcon.vue?vue&type=template&id=64451dc8"
import script from "./OptionIcon.vue?vue&type=script&lang=js"
export * from "./OptionIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__